import { render, staticRenderFns } from "./DashClienteGraficos.vue?vue&type=template&id=60571398&"
import script from "./DashClienteGraficos.vue?vue&type=script&lang=js&"
export * from "./DashClienteGraficos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports